import { ChangeDetectionStrategy, Component, Inject, OnInit, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, catchError, finalize } from 'rxjs/operators';
import { of } from 'rxjs';
import {
  AdaptersHttpService,
  AdapterResponse,
} from 'src/app/services/httpServices/adaptersHttpService/adapters-http.service';
import { LoggerService } from 'src/app/services/infra/logger/logger.service';
import { Label } from 'src/app/labels/englishLabels';

export interface SendToSocDialogData {
  findingId: string;
  integrationId: string;
}

@Component({
  selector: 'app-send-to-soc-dialog',
  templateUrl: './send-to-soc-dialog.component.html',
  styleUrls: ['./send-to-soc-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SendToSocDialogComponent implements OnInit {
  public adapters$!: Observable<AdapterResponse[]>;
  public isLoading$ = new BehaviorSubject<boolean>(true);
  public selectedAdapterId: string | null = null;
  public errorMessage: string | null = null;
  public readonly dialogTitle = Label.get('playbooks.sendToSocActionDisplayName');

  private readonly _adaptersHttpService = inject(AdaptersHttpService);
  private readonly _logger = inject(LoggerService);

  constructor(
    private readonly _dialogRef: MatDialogRef<SendToSocDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SendToSocDialogData
  ) {}

  ngOnInit(): void {
    this._loadAdapters();
  }

  private _loadAdapters(): void {
    this.isLoading$.next(true);

    this.adapters$ = this._adaptersHttpService.getAllAdapters$().pipe(
      // Filter only enabled Splunk adapters
      map((adapters: AdapterResponse[]) =>
        adapters.filter((adapter) => adapter.enabled && adapter.config.adapterType === 'splunk')
      ),
      catchError((error) => {
        this._logger.error('Failed to load adapters:', error);
        this.errorMessage = 'Failed to load adapters';
        return of([]);
      }),
      finalize(() => this.isLoading$.next(false))
    );
  }

  public onCancel(): void {
    this._dialogRef.close();
  }

  public onSend(): void {
    if (!this.selectedAdapterId) {
      return;
    }

    this._dialogRef.close({ adapterId: this.selectedAdapterId });
  }

  public get isSendDisabled(): boolean {
    return !this.selectedAdapterId || this.isLoading$.value;
  }
}
